import Lot from '@/models/Lot';
import Program from '@/models/Program';
import FiltersModule from "@/store/FiltersModule";

export function isBrs(lot: Lot, program: any) {
  const {filters} = FiltersModule
  if(filters.brs) {
    return filters.brs
  }
  const tax_systems = ["RP Tva Réduite/Prix Maitrisé", "Pinel / Rés. principale"]
  const types_to_hide = lot.type
  if(program && lot.program && lot.program.tax_system && lot.type !== 'pro_local' && lot.surface_carrez >= 25) {
      // @ts-ignore
      const isTax = lot.program.tax_system.every(item => tax_systems.includes(item))
      return lot.price / lot.surface_carrez <= 0.7 * program.average_price_per_square_meter && isTax
  }
}